import React from 'react';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Sidebar from 'layout/MainLayout/Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import BackPageButton from 'components/@ui/button/BackPageButton';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import Overlay from 'components/@ui/overlay/Overlay';
import Feedback from 'components/@ui/feedback/Feedback';
import CenteredFeedbackContainer from 'components/@ui/feedback/CenteredFeedbackContainer';
import Logo from 'components/Logo';

// ==============================|| DEFAULT PAGE STRUCTURE ||============================== //

export default function DefaultPageStructure(props) {
  const { navigation } = props;
  const { pathname } = useLocation();
  const { drawerHoverable, drawerOpen } = useSelector((state) => state.menu);

  return (
    <Box
      component="main"
      sx={{
        width: !drawerHoverable && drawerOpen ? 'calc(100vw - 264px)' : 'calc(100vw - 60px)',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        height: '100vh',
        flexGrow: 1,
        color: 'text.dark',
        // backgroundColor: 'pink',
        p: { xs: '12px', sm: '16px' }
      }}
    >
      <Toolbar />
      <Breadcrumbs navigation={navigation} />
      {/* {pathname !== '/dashboard/default' && <BackPageButton />} */}
      <Box className="flex-1 min-h-0 relative">
        <Outlet />
        {/* <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-[0.04] -z-1">
          <Logo width="450" />
        </div> */}
      </Box>
      {/* <Overlay sx={{ backdropFilter: 'blur(1px)', alignItems: 'start' }} visible={true}>
        <CenteredFeedbackContainer>
          <Feedback />
        </CenteredFeedbackContainer>
      </Overlay> */}
      {/* <Sidebar
        sidebarContent={sidebarContent}
        sidebarHeaderContent={sidebarHeaderContent}
        sidebarOpen={sidebarOpen}
        sidebarClose={sidebarClose}
      /> */}
    </Box>
  );
}
